/* WJW59B.4 draft-only visual sale notation for DPO bundle-table variants.
   DPO custom JS/CSS in the app are NOT modified. This decorates its output
   after render, reusing window.productVariantData keyed by input[vid].
   Does NOT change price text, tier rules, quantities, cart calculations. */
(function () {
  'use strict';
  var mobile = window.matchMedia('(max-width: 749px)');
  var pending = false;
  function isTargetTable(t) {
    return !!t && !!t.closest('.wjw59b-mobile-pdp, #Product-Drawer.active');
  }
  function decorate() {
    pending = false;
    if (!mobile.matches || !Array.isArray(window.productVariantData)) return;
    var variants = Object.create(null);
    window.productVariantData.forEach(function (v) {
      if (v && v.id != null) variants[String(v.id)] = v;
    });
    document.querySelectorAll('#bundle-table').forEach(function (table) {
      if (!isTargetTable(table)) return;
      table.querySelectorAll('tbody tr').forEach(function (row) {
        // Available rows use input[vid]; out-of-stock rows use .notif[vid].
        // Both IDs originate from the existing DPO app's variant markup.
        var variantNode = row.querySelector('input[vid], .notif[vid]');
        if (!variantNode) return;
        var v = variants[variantNode.getAttribute('vid')];
        if (!v) return;
        var current = Number(v.price), original = Number(v.compare_at_price);
        if (!(Number.isFinite(original) && Number.isFinite(current) && current > 0 && original > current)) return;
        var pct = Math.round((original - current) * 100 / original);
        if (!(pct > 0)) return;
        var cells = row.cells;
        /* Bundle JS inserts its option columns after hidden SKU; the original
           CSS already places On Sale Now beneath the first option (cell 2). */
        var optionCell = cells.length > 1 ? cells[1] : null;
        var baseCell = row.querySelector('td[q="1"]');
        if (!optionCell || !baseCell || optionCell === baseCell) return;
        if (!row.classList.contains('onsale')) return;
        var saleText = optionCell.querySelector('.wjw59b4-dpo-sale-label');
        if (!saleText) {
          saleText = document.createElement('span');
          saleText.className = 'wjw59b4-dpo-sale-label';
          optionCell.appendChild(saleText);
        }
        saleText.textContent = 'On Sale · ' + pct + '% off';
        var originalText = baseCell.querySelector('.wjw59b4-dpo-compare');
        if (!originalText) {
          originalText = document.createElement('span');
          originalText.className = 'wjw59b4-dpo-compare';
          baseCell.insertBefore(originalText, baseCell.firstChild);
        }
        originalText.textContent = '$' + (original / 100).toFixed(2);
        row.classList.add('wjw59b4-dpo-sale');
      });
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(decorate);
  }
  function boot() {
    /* Observe replacements/re-renders by DPO. Our decoration is idempotent;
       no observers are bound to input values or purchase-button handlers. */
    var watcher = new MutationObserver(function (records) {
      for (var i=0; i<records.length; i++) {
        var rec=records[i];
        if (rec.type !== 'childList') continue;
        var node=rec.target;
        if (node && node.closest && node.closest('#bundle-table')) {
          /* Ignore mutations to our own markup. */
          if (node.closest('.wjw59b4-dpo-compare, .wjw59b4-dpo-sale-label')) continue;
          schedule(); return;
        }
        for (var j=0; j<rec.addedNodes.length; j++) {
          var el=rec.addedNodes[j];
          if (el.nodeType !== 1) continue;
          if ((el.id === 'bundle-table') || (el.querySelector && el.querySelector('#bundle-table'))) {schedule(); return;}
        }
      }
    });
    watcher.observe(document.body, {childList:true, subtree:true});
    if (window.jQuery) window.jQuery(window).on('dpo_initialized dpo_no_options', schedule);
    document.addEventListener('shopify:section:load', schedule);
    if (mobile.addEventListener) mobile.addEventListener('change', schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();
